export function GlassGlow({
  intensity = 0.12,
  size = 70,
  className = "",
}: {
  intensity?: number;
  size?: number;
  className?: string;
}) {
  return (
    <div
      className={`absolute pointer-events-none z-[2] ${className}`}
      style={{
        top: 0,
        left: 0,
        width: `${size}%`,
        height: `${size}%`,
        background: `radial-gradient(ellipse at 12% 12%, rgba(255,255,255,${intensity}) 0%, rgba(255,255,255,${intensity * 0.5}) 25%, rgba(255,255,255,${intensity * 0.15}) 45%, transparent 70%)`,
        borderRadius: "inherit",
      }}
    />
  );
}
